import React from 'react';
import { Announcement } from '@block/plug';

interface Props {
  title: string;
}
class Tip extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { title } = this.props;
    return (
      <div>
        <Announcement title={title || 'test'} type="info" />
      </div>
    );
  }
}

export default Tip;
